export default __webpack_public_path__ + "static/use-case-6.url-0a680e8c4f184b689bc67d90cc4b3efa.svg";